export const SCOPES = {
    DASHBOARD: "DASHBOARD",
    POS: "POS",
    CUSTOMER_DISPLAY: "CUSTOMER_DISPLAY",
    KITCHEN_DISPLAY: "KITCHEN_DISPLAY",
    ORDER_STATUS_DISPLAY: "ORDER_STATUS_DISPLAY",
    ORDER_STATUS: "ORDER_STATUS",
    ORDERS: "ORDERS",
    KITCHEN: "KITCHEN",
    RESERVATIONS: "RESERVATIONS",
    VIEW_RESERVATIONS: "VIEW_RESERVATIONS",
    MANAGE_RESERVATIONS: "MANAGE_RESERVATIONS",
    CUSTOMERS: "CUSTOMERS",
    VIEW_CUSTOMERS: "VIEW_CUSTOMERS",
    MANAGE_CUSTOMERS: "MANAGE_CUSTOMERS",
    INVOICES: "INVOICES",
    MEMBERSHIP: "MEMBERSHIP",
    INVENTORY: "INVENTORY",
    VIEW_INVENTORY: "VIEW_INVENTORY",
    MANAGE_INVENTORY: "MANAGE_INVENTORY",
    SETTINGS: "SETTINGS",
    REPORTS: "REPORTS",
    FEEDBACK: "FEEDBACK",
    EXPENSES: "EXPENSES",
    DAYBOOK: "DAYBOOK",
    SUPPLIERS: "SUPPLIERS",
    PURCHASES: "PURCHASES",
    PURCHASE_INVOICES: "PURCHASE_INVOICES",
    PMS: "PMS",
    ROOMS: "ROOMS",
    HOUSEKEEPING: "HOUSEKEEPING",
    LAUNDRY: "LAUNDRY",
    ACCOUNTING: "ACCOUNTING",
    PAYROLL: "PAYROLL",
    ASSETS: "ASSETS",
    VIEW_ASSETS: "VIEW_ASSETS",
    MANAGE_ASSETS: "MANAGE_ASSETS",
    APPROVE_ASSETS: "APPROVE_ASSETS",
    ASSET_MAINTENANCE: "ASSET_MAINTENANCE",
    ASSET_AUDIT: "ASSET_AUDIT",
    ASSET_ACCOUNTING: "ASSET_ACCOUNTING",
    REQUISITIONS: "REQUISITIONS",
    MANAGE_REQUISITIONS: "MANAGE_REQUISITIONS",
    APPROVE_REQUISITIONS: "APPROVE_REQUISITIONS",
};

export const SCOPE_CATEGORIES = [
  {
    category: "Dashboard & System Settings",
    scopes: [
      { key: SCOPES.DASHBOARD, label: "Dashboard" },
      { key: SCOPES.SETTINGS, label: "Settings & Users" },
    ],
  },
  {
    category: "POS & Orders",
    scopes: [
      { key: SCOPES.POS, label: "POS (Point of Sale)" },
      { key: SCOPES.ORDERS, label: "Orders" },
      { key: SCOPES.ORDER_STATUS, label: "Order Status" },
      { key: SCOPES.ORDER_STATUS_DISPLAY, label: "Order Status Display" },
      { key: SCOPES.KITCHEN, label: "Kitchen" },
      { key: SCOPES.KITCHEN_DISPLAY, label: "Kitchen Display (KDS)" },
      { key: SCOPES.CUSTOMER_DISPLAY, label: "Customer Display" },
    ],
  },
  {
    category: "Property Management & Rooms (PMS)",
    scopes: [
      { key: SCOPES.PMS, label: "PMS (Full Access)" },
      { key: SCOPES.ROOMS, label: "Room Status Grid & Bookings" },
      { key: SCOPES.HOUSEKEEPING, label: "Housekeeping" },
      { key: SCOPES.LAUNDRY, label: "Laundry & Linen" },
    ],
  },
  {
    category: "Inventory & Purchases",
    scopes: [
      { key: SCOPES.INVENTORY, label: "Inventory (Full)" },
      { key: SCOPES.VIEW_INVENTORY, label: "View Inventory" },
      { key: SCOPES.MANAGE_INVENTORY, label: "Manage Inventory" },
      { key: SCOPES.SUPPLIERS, label: "Suppliers" },
      { key: SCOPES.PURCHASES, label: "Purchases" },
      { key: SCOPES.PURCHASE_INVOICES, label: "Purchase Invoices" },
      { key: SCOPES.REQUISITIONS, label: "View Requisitions" },
      { key: SCOPES.MANAGE_REQUISITIONS, label: "Manage Requisitions (Request)" },
      { key: SCOPES.APPROVE_REQUISITIONS, label: "Approve Requisitions & Receive" },
    ],
  },
  {
    category: "Billing, Expenses & Accounting",
    scopes: [
      { key: SCOPES.INVOICES, label: "Invoices & Billing" },
      { key: SCOPES.EXPENSES, label: "Expenses" },
      { key: SCOPES.ACCOUNTING, label: "Bank Accounts & Financials" },
    ],
  },
  {
    category: "Asset Management",
    scopes: [
      { key: SCOPES.ASSETS, label: "Asset Management (Full Access)" },
      { key: SCOPES.VIEW_ASSETS, label: "View Asset Register & Categories" },
      { key: SCOPES.MANAGE_ASSETS, label: "Manage Assets, Assignments & Transfers" },
      { key: SCOPES.APPROVE_ASSETS, label: "Approve Disposals, Acquisitions & Damage" },
      { key: SCOPES.ASSET_MAINTENANCE, label: "Manage Maintenance & Preventive Schedules" },
      { key: SCOPES.ASSET_AUDIT, label: "Conduct Physical Verification & QR Audits" },
      { key: SCOPES.ASSET_ACCOUNTING, label: "Run & Post Depreciation to General Ledger" },
    ],
  },
  {
    category: "Reports & Daybook",
    scopes: [
      { key: SCOPES.REPORTS, label: "Reporting Section (All Reports & Analytics)" },
      { key: SCOPES.DAYBOOK, label: "Daybook (Daily Register & Shifts)" },
    ],
  },
  {
    category: "Guests, Customers & Reservations",
    scopes: [
      { key: SCOPES.CUSTOMERS, label: "Customers (Full)" },
      { key: SCOPES.VIEW_CUSTOMERS, label: "View Customers" },
      { key: SCOPES.MANAGE_CUSTOMERS, label: "Manage Customers" },
      { key: SCOPES.RESERVATIONS, label: "Reservations (Full)" },
      { key: SCOPES.VIEW_RESERVATIONS, label: "View Reservations" },
      { key: SCOPES.MANAGE_RESERVATIONS, label: "Manage Reservations" },
      { key: SCOPES.MEMBERSHIP, label: "Membership" },
      { key: SCOPES.FEEDBACK, label: "Customer Feedback" },
    ],
  },
  {
    category: "HR & Payroll",
    scopes: [
      { key: SCOPES.PAYROLL, label: "HR & Payroll" },
    ],
  },
];

export const getScopeLabel = (scopeKey) => {
  for (const cat of SCOPE_CATEGORIES) {
    const found = cat.scopes.find((s) => s.key === scopeKey);
    if (found) return found.label;
  }
  return scopeKey;
};